import { createRoot } from 'react-dom';
import { useState } from 'react';
import Style from './Components/Common/Style';
import SiteLayoutContainer from './Components/Frontend/SiteLayoutContainer';
import './style.scss';

const AppWrapper = ({ attributes: initialAttributes, elId }) => {
    const [clientTheme, setClientTheme] = useState(initialAttributes.colorTheme || 'dark');
    // Compute attributes dynamically down the tree
    const computedAttributes = { ...initialAttributes, colorTheme: clientTheme };

    return (
        <div className={`gmfBlocksWrapper gmf-theme-${clientTheme}`}>
            <Style attributes={computedAttributes} id={elId} />
            <SiteLayoutContainer attributes={computedAttributes} setClientTheme={setClientTheme} />
        </div>
    );
};

document.addEventListener('DOMContentLoaded', () => {
    const gmfBlocks = document.querySelectorAll('.wp-block-gmf-securities-site-layout');
    gmfBlocks.forEach((el) => {
        const attributes = JSON.parse(el.dataset.attributes);
        createRoot(el).render(<AppWrapper attributes={attributes} elId={el.id} />);
        el.removeAttribute('data-attributes');
    });
});
